import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "app/modules/shared/services/api.service";
import * as moment from "moment";
import { resolveAxisAnchorDate } from 'app/shared/utils/analytics-axis.util';
import * as _ from "underscore";
import { debounceTime, distinctUntilChanged, Subscription } from "rxjs";
import * as FileSaver from "file-saver";
import { AlertMessage } from "app/shared/utils/alertMessage";
import { RolePipePipe } from "../user-details-dialog/role-pipe.pipe";
import { HighchartsComponent } from "app/modules/shared/highcharts/highcharts.component";
import { CryptoService } from "app/shared/utils/crypto.service";

@Component({
  selector: "app-practice-set-analytics",
  templateUrl: "./practice-set-analytics.component.html",
  styleUrls: ["./practice-set-analytics.component.scss"],
})
export class PracticeSetAnalyticsComponent implements OnInit, OnDestroy {
  updateChartMonth = false;
  updateChartLiveSession = false;
  totalLessionsSessions = 7;
  @ViewChild("highchartsComponentMonth") highchartsComponentMonth: HighchartsComponent;
  @ViewChild("highchartsComponentLiveSession") highchartsComponentLiveSession: HighchartsComponent;

  dateRangeType = "Day";
  subSink: Subscription;
  @Output() exit = new EventEmitter();
  liveSessionDates: any;
  key: string;
  liveSessionUsageList = [];
  usageChartDatasets: Array<any>;
  usageChartLabels: Array<any> = [];

  usageAnalytics = [
    { viewValue: "All", value: "all" },
    { viewValue: "Session Played", value: "totalSessionPlayed" },
    { viewValue: "Num. Of Users", value: "totalUsers" },
    { viewValue: "Times Mastered", value: "totalsessionMastered" },
  ];

  usageAtcAnalytics = [
    { viewValue: 'All', value: 'all' },
    { viewValue: 'Average Session Duration', value: 'totalSessionDurationAvg' },
    { viewValue: "Session Played", value: "totalSessionPlayed" },
    { viewValue: "Times Mastered", value: "totalsessionMastered" },
    { viewValue: 'Incorrect Sessions', value: 'incorrectSession' }
  ];

  liveSessionStatus = [
    { viewValue: "Complete", value: "complete" },
    { viewValue: "InComplete", value: "inComplete" },
  ];

  usageAnalyticsUserExists = [
    { viewValue: "All", value: "all" },
    { viewValue: "Average Session Duration", value: "averageDuration" },
    { viewValue: "Total Practice Set Sessions", value: "totalSessionPlayed" },
    { viewValue: "Mastered Practice Sets", value: "totalsessionMastered" },
  ];

  usageAtcAnalyticsUserExists = [
    { viewValue: "All", value: "all" },
    { viewValue: "Average Session Duration", value: "totalSessionDurationAvg" },
    { viewValue: "Total Practice Set Sessions", value: "totalSessionPlayed" },
    { viewValue: "Mastered Practice Sets", value: "totalsessionMastered" },
    { viewValue: 'Incorrect Sessions', value: 'incorrectSession' },
  ];
  usageAnalyticsSelectedValue: string = "all";
  liveSessionUsageValue: string = "complete";

  liveSessionChartDatasets: Array<any>;
  liveSessionChartLabels: Array<any> = [];
  usageDateRange: any;
  usageDates: any;
  typeUser: string = "Day";
  typeRecords: string = "Day";
  typeUsage: string = "Day";
  typeLiveSession: string = "Day";
  data = {
    users: undefined,
    records: undefined,
    id: undefined,
    name: undefined,
    username: null,
    userExists: false,
  };
  folderName: any;
  usageColors = [
    {
      backgroundColor: "rgba(255, 255, 255, .2)",
      borderColor: "rgb(215, 38, 61)",
      borderWidth: 2,
      name: "Session Played",
    },
    {
      backgroundColor: "rgba(255, 255, 255, .2)",
      borderColor: "rgb(112, 0, 152)",
      borderWidth: 2,
      name: "Num. Of Users",
    },
    {
      backgroundColor: "rgba(255, 255, 255, .2)",
      borderColor: "rgb(45, 134, 86)",
      borderWidth: 2,
      name: "Times Mastered",
    },
  ];
  usageColorsUserExists = [
    {
      backgroundColor: "rgba(255, 255, 255, .2)",
      borderColor: "rgb(112, 0, 152)",
      borderWidth: 2,
      name: "Average Session Duration",
    },
    {
      backgroundColor: "rgba(255, 255, 255, .2)",
      borderColor: "rgb(215, 38, 61)",
      borderWidth: 2,
      name: "Total Practice Set Sessions",
    },
    {
      backgroundColor: "rgba(255, 255, 255, .2)",
      borderColor: "rgb(45, 134, 86)",
      borderWidth: 2,
      name: "Mastered Practice Sets",
    },
  ];
  liveSessionColors = [
    {
      backgroundColor: "rgba(255, 255, 255, .2)",
      borderColor: "rgb(0,118,187)",
      borderWidth: 2,
      name: "Correct Answer",
    },
    {
      backgroundColor: "rgba(255, 255, 255, .2)",
      borderColor: "rgb(215, 38, 61)",
      borderWidth: 2,
      name: "Incorrect Answer",
    },
  ];

  breadCrumb: any;
  breadCrumbUser: any;
  dateType: any = { type: "Day" };
  @Input() psParams: any;
  selectedApp: any;
  sessionData: any;
  dateInfo: string;
  dateValue: any;

  constructor(private route: ActivatedRoute, public api: ApiService, public dialog: MatDialog, private router: Router, private crypto: CryptoService) {
    let word: any = JSON.parse(localStorage.getItem("breadCrumb"));
    if (word) {
      this.breadCrumb = word[0].name;
      const userIndex = word.filter((v) => v.icon == "fa fa-user");
      if (userIndex && userIndex.length > 0) {
        this.breadCrumbUser = userIndex[0].name;
      }
    }

    this.selectedApp = JSON.parse(localStorage.getItem("selectedApp"));
    const dataID = this.route.snapshot.params["id"];
    if (this.selectedApp && dataID) {
      this.selectedApp.dataId = dataID;
    }
  }

  getDate(e) {
    this.api.changeMessage(e);
  }

  ngOnChanges() {
    if (this.selectedApp.title == "ERAM Keyboard") {
      this.totalLessionsSessions = 2;
    }
  }

  updateGameData() {
    const queryParams = { view: "membersAnalytics" };
    this.api.addRoute(1);
    this.router.navigate(["main/user/details", this.data.username], { queryParams });
  }

  openUserDialog(event) {
    this.api.showDateSelector = false;
    if (this.key !== "pSetAnalytics") {
      // this.dialog.open(TableComponent,
      //   {
      //     data: {
      //       api: '/analytics/practicesets/' + this.data.id + '/practiceSetActiveUsersUsageDetails?',
      //       header: 'Users/Nickname',
      //       rediretionUrl: 'main/user/details',
      //       redirectionKey: 'username',
      //       dateParameter: 'PracticeSet'
      //     },
      //     width: '900px',
      //     height: '550px',
      //   })
      // this.router.navigate([this.dialogData.rediretionUrl, e[this.dialogData.redirectionKey]]);
      const name = event.role == "Guest" ? event.nickname : event.username;
      this.router.navigate(["main/practiceSet/analytics/user", "member", this.data.id, this.data.name, name]);
    }
  }

  getUsers(e) {
    this.data.users = undefined;
    var path = "";
    if (this.selectedApp && (this.selectedApp.title == "ATC Phraseology" || this.selectedApp.name == "ATC Phraseology")) {
      path = "/atc";
    }
    this.api.get(path + "/analytics/practicesets/" + this.data.id + "/practiceSetActiveUsersUsage?" + (e.date ? e.date : e.type.toLowerCase() + "=" + e.type.toLowerCase())).subscribe(
      (success) => {
        if (success && success.length > 0) {
          this.data.users = success.map((data) => {
            const name = ((data.firstName ? data.firstName : "") + " " + (data.lastName ? data.lastName : "")).split(" ");
            data = {
              nameIcon: name[0] ? (name[0].split("")[0] ? name[0].split("")[0] : "") + (name[1] ? name[1].split("")[0] : name[0].split("")[1] ? name[0].split("")[1] : "") : data.username.slice(0, 2),
              fullName: data.firstName && data.firstName.trim() !== "" ? (data.firstName ? data.firstName : "") + (data.lastName ? " " + data.lastName : "") : data.username,
              email: data.email,
              nickname: new RolePipePipe().transform(data, "Guest") ? data.username : "",
              username: new RolePipePipe().transform(data, "Guest") ? "" : data.username,
              color: data.color,
              active: moment(data.active).format("LL"),
              role: new RolePipePipe().transformByRole(data),
            };
            return data;
          });
        } else {
          this.data.users = [];
        }
      },
      (err) => {
        this.getError(err);
      }
    );
  }

  async getListOfRecords(e) {
    this.data.records = undefined;
    let nameStr = this.crypto.isProbablyEncrypted(this.data.username) ? this.data.username : await this.crypto.encryptData(this.data.username);

    var path = "";
    if (this.selectedApp && (this.selectedApp.title == "ATC Phraseology" || this.selectedApp.name == "ATC Phraseology")) {
      path = "/atc";
    }
    this.api
      .get(path + "/analytics/practicesets/" + this.data.id + "/pratSetQuesRecordAnalyticsUsage?selectedUserName=" + nameStr + "&" + (e.date ? e.date : e.type.toLowerCase() + "=" + e.type.toLowerCase()))
      .subscribe(
        (success) => {
          if (success && success.QuestionRecords) {
            this.data.records = success.QuestionRecords.map((data) => {
              delete data.id;
              data = {
                recordNumber: data.recordNumber,
                "#Shown": data.shown,
                "#Correct": data.numberCorrect,
                "#Incorrect": data.numberIncorrect,
                "%Correct": data.correctPercentage,
              };
              return data;
            });
          } else {
            this.data.records = [];
          }
        },
        (err) => {
          this.getError(err);
        }
      );
  }

  async getPratSetSessionData(e) {
    this.sessionData = [];
    this.sessionData = undefined;
    let nameStr = this.crypto.isProbablyEncrypted(this.data.username) ? this.data.username : await this.crypto.encryptData(this.data.username);

    var path = "";
    if (this.selectedApp && (this.selectedApp.title == "ATC Phraseology" || this.selectedApp.name == "ATC Phraseology")) {
      path = "/atc";
    }

    this.api
      .get(path + "/analytics/practicesets/" + this.data.id + "/getPratSetSessionData?selectedUserName=" + nameStr + "&" + (e.date ? e.date : e.type.toLowerCase() + "=" + e.type.toLowerCase()))
      .subscribe(
        (success) => {
          if (success) {
            this.sessionData = success.map((data) => {
              if (this.selectedApp && (this.selectedApp.title == "ATC Phraseology" || this.selectedApp.name == "ATC Phraseology")) {
                data = {
                  "Session Date": moment(new Date(data["Session Date"])).format("MMMM D, YYYY"),
                  Duration: data.Duration,
                  Score: data.Score,
                  wordPerMin: data.wordPerMin,
                  Status: data.Status,                  
                };
              } else {
                data = {
                  "Session Date": moment(new Date(data["Session Date"])).format("MMMM D, YYYY"),
                  Duration: data.Duration,
                  Score: data.Score,
                  Status: data.Status,
                };
              }
              return data;
            });
          } else {
            this.sessionData = [];
          }
        },
        (err) => {
          this.getError(err);
        }
      );
  }

  getNoOfQuesLabels() {
    let quesLabels = [];
    for (let i = 1; i <= this.liveSessionUsageList.length; i++) {
      quesLabels.push("Question " + i);
    }
    return quesLabels;
  }

  getLastFiveWeeks() {
    let noOfWeeks = [];
    for (let i = 1; i <= 5; i++) {
      noOfWeeks.push("Week " + i);
    }
    return noOfWeeks;
  }

  getLastThirtyDaysDefault(data) {
    let daysDate = [];
    // SG-8323 (Issue 8): anchor the axis to the date that was requested rather than the
    // browser clock, so a client/server disagreement about "today" cannot shift every label.
    const anchorDate = resolveAxisAnchorDate(data);
    for (let i = 0; i < data.count; i++) {
      let date = new Date(anchorDate);
      if (data.type === "month") {
        const selectedMonth = moment(date).subtract(i, "months");
        daysDate.push(moment(selectedMonth).format("MMM YYYY"));
      } else if (data.type === "year") {
        var selectedYear = moment(date).subtract(i, "years");
        daysDate.push(moment(selectedYear).format("YYYY"));
      } else {
        date.setDate(date.getDate() - i);
        daysDate.push(moment(date).format("ddd, MMM D"));
      }
    }
    return daysDate.reverse();
  }

  getLastThirtyDays(timepointPlayed: string[]): string[] {
    return timepointPlayed.map(dateStr => {
      const [month, day, year] = dateStr.split("-").map(Number);
      const date = new Date(year, month - 1, day);

      return date.toLocaleDateString("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric"
      });
    });
  }

  getLastTwentyFourMonth(timepointPlayed: string[]): string[] {
      return timepointPlayed.map(dateStr => {
        const [month, year] = dateStr.split("-").map(Number);
        const date = new Date(year, month - 1);
  
        return date.toLocaleDateString("en-US", {
          month: "short",
          year: "numeric"
        });
      });
  }

  getDatesBetweenStartAndEndDefault(startDate, endDate) {
    let date = [];
    while (moment(startDate) <= moment(endDate)) {
      date.push(moment(startDate).format("ddd, MMM D"));
      startDate = moment(startDate).add(1, "days").format("YYYY-MM-DD");
    }
    return date;
  }

  getDatesBetweenStartAndEnd(timepointPlayed: string[]): string[] {
    return timepointPlayed.map(dateStr => {
      const [month, day, year] = dateStr.split("-").map(Number);
      const date = new Date(year, month - 1, day);

      return date.toLocaleDateString("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric"
      });
    });
  }

  changeAnalytics(value) {
    this.usageAnalyticsSelectedValue = value;
    this.getUsageRecordsOnType(this.dateType, this.usageAnalyticsSelectedValue);
  }

  async getUsageRecordsOnType(type, usageValue) {
    this.updateChartMonth = false;
    let selectData: string = type.type;
    let count = type.count;
    let date;
    let startDate;
    let endDate;
    if (type.type == "Day") {
      this.usageDateRange = "daySelected";
      selectData = type.type.toLowerCase();
      count = 31;
      this.usageDates = moment(new Date()).subtract(1, "d").format("MM/DD/YYYY") + " - " + moment(new Date()).format("MM/DD/YYYY");
    } else if (type.type == "Month") {
      this.usageDateRange = "monthSelected";
      selectData = type.type.toLowerCase();
      count = 24;
      this.usageDates = moment(new Date()).subtract(1, "M").format("MM/DD/YYYY") + " - " + moment(new Date()).format("MM/DD/YYYY");
    } else if (type.type == "Year") {
      this.usageDateRange = "yearSelected";
      selectData = type.type.toLowerCase();
      count = 5;
      this.usageDates = moment(new Date()).subtract(1, "y").format("MM/DD/YYYY") + " - " + moment(new Date()).format("MM/DD/YYYY");
    } else if (type.type == "range") {
      this.usageDateRange = "rangeSelected";
      selectData = type.type.toLowerCase();
      date = type.date.split("&");
      startDate = date[0].split("=");
      endDate = date[1].split("=");
    }
    let totalSessionPlayedList = [];
    let totalNumbersOfUsersList = [];
    let totalSessionMasteredList = [];
    let totalSessionPlayedAvgDurationList = [];
    let incorrectSessionPlayedList = [];
    this.usageChartDatasets = undefined;

    const nameStr = this.crypto.isProbablyEncrypted(this.data.username) ? this.data.username : await this.crypto.encryptData(this.data.username);

    var path = "";
    if (this.selectedApp && (this.selectedApp.title == "ATC Phraseology" || this.selectedApp.name == "ATC Phraseology")) {
      path = "/atc";
    }

    this.api
      .get(path + "/analytics/practicesets/" + this.data.id + "/practiceSetAnalyticsUsage?selectedUserName=" + nameStr + "&" + (type.date ? type.date : "usageType=" + type.type.toLowerCase()))
      .subscribe(
        (success) => {
          if (success && success[0]) {
            const timepointPlayed = success?.[0]?.["Timepoint"];
            if (selectData == "day" || selectData == "month" || selectData == "year") {
              if (timepointPlayed) {
                if (selectData == "day") {  
                  this.usageChartLabels = this.getLastThirtyDays(timepointPlayed);
                } else if (selectData == "month") {  
                  this.usageChartLabels = this.getLastTwentyFourMonth(timepointPlayed);
                } else if (selectData == "year") {  
                  this.usageChartLabels = timepointPlayed;
                }
              } else {
                // SG-8323 (Issue 8): pass the requested date through so the axis is anchored to it.
                this.usageChartLabels = this.getLastThirtyDaysDefault({ type: selectData, count: count, from: type.from });
              }
            } else {
              if (timepointPlayed) {
                this.usageChartLabels = this.getDatesBetweenStartAndEnd(timepointPlayed);
              } else {
                this.usageChartLabels = this.getDatesBetweenStartAndEndDefault(startDate[1], endDate[1]);
              }
            }
            if (usageValue === "totalSessionPlayed") {
              if (!_.isUndefined(success[0]["totalSessionPlayed"]) && success[0]["totalSessionPlayed"].length !== 0) {
                totalSessionPlayedList = success[0]["totalSessionPlayed"];
                if (this.data.userExists) {
                  this.usageChartDatasets = [{ data: totalSessionPlayedList, label: "Total Practice Set Sessions" }];
                } else {
                  this.usageChartDatasets = [{ data: totalSessionPlayedList, label: "Session Played" }];
                }
              }
            } else if (usageValue === "totalUsers" && !this.data.userExists) {
              if (!_.isUndefined(success[0]["totalNumbersOfUsers"]) && success[0]["totalNumbersOfUsers"].length !== 0) {
                totalNumbersOfUsersList = success[0]["totalNumbersOfUsers"].map((v) => Number(v));
                this.usageChartDatasets = [{ data: totalNumbersOfUsersList, label: "Num. Of Users" }];
              }
            } else if (usageValue === "totalSessionDurationAvg") {
              if (!_.isUndefined(success[0]["totalSessionDurationAvg"]) && success[0]["totalSessionDurationAvg"].length !== 0) {
                totalSessionPlayedAvgDurationList = success[0]["totalSessionDurationAvg"].map((v) => Number(v));
                this.usageChartDatasets = [{ data: totalSessionPlayedAvgDurationList, label: "Average Session Duration" }];
              }
            } else if (usageValue === "averageDuration" && this.data.userExists) {
              if (!_.isUndefined(success[0]["averageDuration"]) && success[0]["averageDuration"].length !== 0) {
                totalSessionPlayedAvgDurationList = success[0]["averageDuration"].map((v) => Number(v));
                this.usageChartDatasets = [{ data: totalSessionPlayedAvgDurationList, label: "Average Session Duration" }];
              }
            } else if (usageValue === "totalsessionMastered") {
              if (!_.isUndefined(success[0]["totalSessionMastered"]) && success[0]["totalSessionMastered"].length != 0) {
                totalSessionMasteredList = success[0]["totalSessionMastered"].map((v) => Number(v));
                if (this.data.userExists) {
                  this.usageChartDatasets = [{ data: totalSessionMasteredList, label: "Mastered Practice Sets" }];
                } else {
                  this.usageChartDatasets = [{ data: totalSessionMasteredList, label: "Times Mastered" }];
                }
              }
            } else if (usageValue === "incorrectSession") {
              if (!_.isUndefined(success[0]["incorrectSession"]) && success[0]["incorrectSession"].length != 0) {
                incorrectSessionPlayedList = success[0]["incorrectSession"].map((v) => Number(v));
                if (this.data.userExists) {
                  this.usageChartDatasets = [{ data: incorrectSessionPlayedList, label: "Incorrect Sessions" }];
                } else {
                  this.usageChartDatasets = [{ data: incorrectSessionPlayedList, label: "Incorrect Sessions" }];
                }
              }
            } else {
              if (!_.isUndefined(success[0]["totalSessionPlayed"]) && success[0]["totalSessionPlayed"].length != 0) {
                totalSessionPlayedList = success[0]["totalSessionPlayed"].map((v) => Number(v));
              }
              if (!_.isUndefined(success[0]["totalNumbersOfUsers"]) && success[0]["totalNumbersOfUsers"].length != 0) {
                totalNumbersOfUsersList = success[0]["totalNumbersOfUsers"].map((v) => Number(v));
              }
              if (!_.isUndefined(success[0]["totalSessionDurationAvg"]) && success[0]["totalSessionDurationAvg"].length != 0) {
                totalSessionPlayedAvgDurationList = success[0]["totalSessionDurationAvg"].map((v) => Number(v));
              }
              if (!_.isUndefined(success[0]["averageDuration"]) && success[0]["averageDuration"].length != 0) {
                totalSessionPlayedAvgDurationList = success[0]["averageDuration"].map((v) => Number(v));
              }
              if (!_.isUndefined(success[0]["totalSessionMastered"]) && success[0]["totalSessionMastered"].length != 0) {
                totalSessionMasteredList = success[0]["totalSessionMastered"].map((v) => Number(v));
              }
              if (!_.isUndefined(success[0]["incorrectSession"]) && success[0]["incorrectSession"].length != 0) {
                incorrectSessionPlayedList = success[0]["incorrectSession"].map((v) => Number(v));
              }

              if (this.data.userExists) {
                if (this.selectedApp && (this.selectedApp.title == "ATC Phraseology" || this.selectedApp.name == "ATC Phraseology")) {
                  this.usageChartDatasets = [
                    { data: totalSessionPlayedAvgDurationList, label: "Average Session Duration" },
                    { data: totalSessionPlayedList, label: "Total Practice Set Sessions" },
                    { data: totalSessionMasteredList, label: "Mastered Practice Sets" },
                    { data: incorrectSessionPlayedList, label: "Incorrect Sessions" },
                  ];
                } else {
                  this.usageChartDatasets = [
                    { data: totalSessionPlayedAvgDurationList, label: "Average Session Duration" },
                    { data: totalSessionPlayedList, label: "Total Practice Set Sessions" },
                    { data: totalSessionMasteredList, label: "Mastered Practice Sets" },
                  ];
                }
              } else {
                if (this.selectedApp && (this.selectedApp.title == "ATC Phraseology" || this.selectedApp.name == "ATC Phraseology")) {
                  this.usageChartDatasets = [
                    { data: totalSessionPlayedAvgDurationList, label: "Average Session Duration" },
                    { data: totalSessionPlayedList, label: "Session Played" },
                    { data: totalSessionMasteredList, label: "Times Mastered" },
                    { data: incorrectSessionPlayedList, label: "Incorrect Sessions" },
                  ];
                } else {
                  this.usageChartDatasets = [
                    { data: totalSessionPlayedList, label: "Session Played" },
                    { data: totalNumbersOfUsersList, label: "Num. Of Users" },
                    { data: totalSessionMasteredList, label: "Times Mastered" },
                  ];
                }
              }
            }
            this.highchartsComponentMonth.updateChartData(this.usageChartLabels, this.usageChartDatasets);
            this.updateChartMonth = true;
          } else {
            this.usageChartDatasets = [];
          }
        },
        (err) => {
          this.getError(err);
        }
      );
  }

  async getUsageRecords(type) {
    this.updateChartMonth = false;
    let selectData: string = type.type;
    let count = type.count;
    let date;
    let startDate;
    let endDate;
    if (type.type == "Day") {
      this.usageDateRange = "daySelected";
      selectData = type.type.toLowerCase();
      count = 31;
      this.usageDates = moment(new Date()).subtract(1, "d").format("MM/DD/YYYY") + " - " + moment(new Date()).format("MM/DD/YYYY");
    } else if (type.type == "Month") {
      this.usageDateRange = "monthSelected";
      selectData = type.type.toLowerCase();
      count = 24;
      this.usageDates = moment(new Date()).subtract(1, "M").format("MM/DD/YYYY") + " - " + moment(new Date()).format("MM/DD/YYYY");
    } else if (type.type == "Year") {
      this.usageDateRange = "yearSelected";
      selectData = type.type.toLowerCase();
      count = 5;
      this.usageDates = moment(new Date()).subtract(1, "y").format("MM/DD/YYYY") + " - " + moment(new Date()).format("MM/DD/YYYY");
    } else if (type.type == "range") {
      this.usageDateRange = "rangeSelected";
      selectData = type.type.toLowerCase();
      date = type.date.split("&");
      startDate = date[0].split("=");
      endDate = date[1].split("=");
    }
    let totalSessionPlayedList = [];
    let totalNumbersOfUsersList = [];
    let totalSessionMasteredList = [];
    let totalSessionPlayedAvgDurationList = [];
    let incorrectSessionPlayedList = [];

    const nameStr = this.crypto.isProbablyEncrypted(this.data.username) ? this.data.username : await this.crypto.encryptData(this.data.username);

    var path = "";
    if (this.selectedApp && (this.selectedApp.title == "ATC Phraseology" || this.selectedApp.name == "ATC Phraseology")) {
      path = "/atc";
    }

    this.api
      .get(path + "/analytics/practicesets/" + this.data.id + "/practiceSetAnalyticsUsage?selectedUserName=" + nameStr + "&" + (type.date ? type.date : "usageType=" + type.type.toLowerCase()))
      .subscribe(
        (success) => {
          if (success && success[0]) {
            if (!_.isUndefined(success[0]["totalSessionPlayed"]) && success[0]["totalSessionPlayed"].length !== 0) {
              totalSessionPlayedList = success[0]["totalSessionPlayed"].map((v) => Number(v));
            }
            if (!_.isUndefined(success[0]["totalNumbersOfUsers"]) && success[0]["totalNumbersOfUsers"].length !== 0) {
              totalNumbersOfUsersList = success[0]["totalNumbersOfUsers"].map((v) => Number(v));
            }
            if (!_.isUndefined(success[0]["totalSessionDurationAvg"]) && success[0]["totalSessionDurationAvg"].length !== 0) {
              totalSessionPlayedAvgDurationList = success[0]["totalSessionDurationAvg"].map((v) => Number(v));
            }
            if (!_.isUndefined(success[0]["averageDuration"]) && success[0]["averageDuration"].length !== 0) {
              totalSessionPlayedAvgDurationList = success[0]["averageDuration"].map((v) => Number(v));
            }
            if (!_.isUndefined(success[0]["totalSessionMastered"]) && success[0]["totalSessionMastered"].length !== 0) {
              totalSessionMasteredList = success[0]["totalSessionMastered"].map((v) => Number(v));
            }
            if (!_.isUndefined(success[0]["incorrectSession"]) && success[0]["incorrectSession"].length !== 0) {
              incorrectSessionPlayedList = success[0]["incorrectSession"].map((v) => Number(v));
            }
            const timepointPlayed = success?.[0]?.["Timepoint"];
            if (selectData == "day" || selectData == "month" || selectData == "year") {              
              if (timepointPlayed) {
                if (selectData == "day") {  
                  this.usageChartLabels = this.getLastThirtyDays(timepointPlayed);
                } else if (selectData == "month") {  
                  this.usageChartLabels = this.getLastTwentyFourMonth(timepointPlayed);
                } else if (selectData == "year") {  
                  this.usageChartLabels = timepointPlayed;
                }
              } else {
                // SG-8323 (Issue 8): pass the requested date through so the axis is anchored to it.
                this.usageChartLabels = this.getLastThirtyDaysDefault({ type: selectData, count: count, from: type.from });
              }
            } else {
              if (timepointPlayed) {
                this.usageChartLabels = this.getDatesBetweenStartAndEnd(timepointPlayed);
              } else {
                this.usageChartLabels = this.getDatesBetweenStartAndEndDefault(startDate[1], endDate[1]);
              }
            }
            if (this.data.userExists) {
              if (this.selectedApp && (this.selectedApp.title == "ATC Phraseology" || this.selectedApp.name == "ATC Phraseology")) {
                this.usageChartDatasets = [
                  { data: totalSessionPlayedAvgDurationList, label: "Average Session Duration" },
                  { data: totalSessionPlayedList, label: "Total Practice Set Sessions" },
                  { data: totalSessionMasteredList, label: "Mastered Practice Sets" },
                  { data: incorrectSessionPlayedList, label: "Incorrect Sessions" },
                ];
              } else {
                this.usageChartDatasets = [
                  { data: totalSessionPlayedAvgDurationList, label: "Average Session Duration" },
                  { data: totalSessionPlayedList, label: "Total Practice Set Sessions" },
                  { data: totalSessionMasteredList, label: "Mastered Practice Sets" },
                ];
              }
            } else {
              if (this.selectedApp && (this.selectedApp.title == "ATC Phraseology" || this.selectedApp.name == "ATC Phraseology")) {
                this.usageChartDatasets = [
                  { data: totalSessionPlayedAvgDurationList, label: "Average Session Duration" },
                  { data: totalSessionPlayedList, label: "Session Played" },
                  { data: totalSessionMasteredList, label: "Times Mastered" },
                  { data: incorrectSessionPlayedList, label: "Incorrect Sessions" },
                ];
              } else {
                this.usageChartDatasets = [
                  { data: totalSessionPlayedList, label: "Session Played" },
                  { data: totalNumbersOfUsersList, label: "Num. Of Users" },
                  { data: totalSessionMasteredList, label: "Times Mastered" },
                ];
              }
            }
            this.highchartsComponentMonth.updateChartData(this.usageChartLabels, this.usageChartDatasets);
            this.updateChartMonth = true;
          } else {
            this.usageChartDatasets = [];
          }
        },
        (err) => {
          this.getError(err);
        }
      );
  }

  async getLiveSessionRecords(type) {
    const nameStr = this.crypto.isProbablyEncrypted(this.data.username) ? this.data.username : await this.crypto.encryptData(this.data.username);
    this.updateChartLiveSession = false;
    let selectData: string = "";
    if (type.type == "Day") {
      selectData = type.type.toLowerCase();
      this.liveSessionDates = moment(new Date()).subtract(1, "d").format("MM/DD/YYYY") + " - " + moment(new Date()).format("MM/DD/YYYY");
    } else if (type == "Month") {
      selectData = type.type.toLowerCase();
      this.liveSessionDates = moment(new Date()).subtract(1, "M").format("MM/DD/YYYY") + " - " + moment(new Date()).format("MM/DD/YYYY");
    } else if (type == "Year") {
      selectData = "Year";
      this.liveSessionDates = moment(new Date()).subtract(1, "y").format("MM/DD/YYYY") + " - " + moment(new Date()).format("MM/DD/YYYY");
    } else if (type == "range") {
      selectData = type.type.toLowerCase();
    }
    let wrongAnswersList: any = [];
    let correctAnswersList: any = [];
    let backgroundColorWrongAnswer: any = [];
    let borderColorWrongAnswer: any = [];
    let backgroundColorCorrectAnswer: any = [];
    let borderColorCorrectAnswer: any = [];
    // Live-session graph uses the generic endpoint for ALL apps (including ATC Phraseology).
    // Previously ATC Phraseology prepended "/atc" -> "/atc/analytics/practicesets/.../liveSessionUsage";
    // that prefix is intentionally dropped so ATC hits the same "/analytics/practicesets/.../liveSessionUsage".
    var path = "";
    this.api
      .get(
        path + "/analytics/practicesets/" +
        this.data.id +
        "/liveSessionUsage?selectedUserName=" +
        nameStr +
        "&" +
        (type.date ? type.date : "usageType=" + type.type.toLowerCase()) +
        ("&status=" + this.liveSessionUsageValue)
      )
      .subscribe(
        (success) => {
          let dataList: any = success;
          if (!_.isUndefined(dataList) && dataList.length > 0) {
            this.liveSessionUsageList = dataList;
            for (let i = 0; i < this.liveSessionUsageList.length; i++) {
              if (_.has(this.liveSessionUsageList[i], "wrongAnswers") && !_.isUndefined(this.liveSessionUsageList[i].wrongAnswers)) {
                wrongAnswersList.push(this.liveSessionUsageList[i]["wrongAnswers"]);
                backgroundColorWrongAnswer.push("rgb(215, 38, 61)");
                //   borderColorWrongAnswer.push('rgba(255,0,0, 1)');
              }
              if (_.has(this.liveSessionUsageList[i], "correctAnswers") && !_.isUndefined(this.liveSessionUsageList[i].correctAnswers)) {
                correctAnswersList.push(this.liveSessionUsageList[i]["correctAnswers"]);
                backgroundColorCorrectAnswer.push("rgb(0,118,187)");
                // borderColorCorrectAnswer.push('rgba(30,144,255, 1)');
              }
            }
            this.liveSessionChartDatasets = [
              { data: correctAnswersList, label: "Correct Answer" },
              { data: wrongAnswersList, label: "Incorrect Answer" },
            ];
            this.liveSessionChartLabels = this.getNoOfQuesLabels();
            this.highchartsComponentLiveSession.updateChartData(this.liveSessionChartLabels, this.liveSessionChartDatasets, true);
            this.updateChartLiveSession = true;
          } else {
            this.liveSessionChartDatasets = [];
          }
        },
        (err) => {
          this.getError(err);
        }
      );
  }

  ngOnInit() {
    this.api.showDateSelector = true;
    let breadCrumb = JSON.parse(localStorage.getItem("breadCrumb"));
    if (breadCrumb.length < 2 && !window.location.href.includes("user/member")) {
      localStorage.removeItem("dateRange");
    }
    this.api.showApplibraryList = false;
    this.api.newAppBreadcrumb = true;
    if ((this.selectedApp && this.selectedApp.title == "ERAM Keyboard") || this.selectedApp.title == "Advanced Vectoring" || this.selectedApp.title == "Basic Vectoring"
           || this.selectedApp.title == "STARS Keyboard") {
      return;
    }
    
    this.route.params.subscribe((data) => {
      //this.selectedApp = JSON.parse(localStorage.getItem("selectedApp"));
      if (this.selectedApp && (this.selectedApp.title == "ATC Phraseology" || this.selectedApp.name == "ATC Phraseology")) {
        this.usageAnalytics = this.usageAtcAnalytics;
      }
      if (this.psParams) {
        this.key = "pSetAnalytics";
        data = this.psParams;
        console.log(data);
      }
      if (data.id) {
        if (data.view || data.username || data.folder) {
          this.api.addRoute(0, data.view == "member" ? data.username : data.name);
        }
        localStorage.setItem("analyticsEnabled", "true");
        this.data.name = data.name;
        this.data.id = data.id;
        if (typeof data.username !== "undefined") {
          this.api.showApplibraryList = true;
          this.data.username = data.username;
          this.data.userExists = true;
          if (this.selectedApp && (this.selectedApp.title == "ATC Phraseology" || this.selectedApp.name == "ATC Phraseology")) {
            this.usageAnalytics = this.usageAtcAnalyticsUserExists;
          } else {
            this.usageAnalytics = this.usageAnalyticsUserExists;
          }
          this.usageColors = this.usageColorsUserExists;
          // this.getPratSetSessionData({ type: 'day' });
        }
        // ***********  SG-7203 start*************************

        // this.getUsers({ type: 'day' });
        // this.getListOfRecords({ type: 'day' });
        // this.getUsageRecords({ type: 'day', count: 31 });
        // this.getLiveSessionRecords({ type: 'day' });
        // ***********  SG-7203 end*************************
      }
    });
    this.subSink = this.api.dateRange$.pipe(debounceTime(500), distinctUntilChanged()).subscribe((next) => {
      //this.selectedApp = JSON.parse(localStorage.getItem("selectedApp"));
      if (next) {
        this.dateInfo = localStorage.getItem("dateRange");
        if (this.dateInfo) {
          next = JSON.parse(this.dateInfo);
        }
        this.dateRangeType = next.type;
        this.dateType = next;
        console.log(this.dateType);
        // this.usageAnalyticsSelectedValue = 'all';
        this.getUsers(next);
        this.getPratSetSessionData(next);
        this.getListOfRecords(next);
        this.getUsageRecordsOnType(next, this.usageAnalyticsSelectedValue);
        this.getLiveSessionRecords(next);
        this.dateValue = next;
      }
    });
  }

  async getCsvData(analyticsType) {
    let type = this.dateType.type.toLowerCase();
    let nameStr = this.crypto.isProbablyEncrypted(this.data.username) ? this.data.username : await this.crypto.encryptData(this.data.username);
    // ONLY the live-session export ('session') drops the "/atc" path: it uses the generic
    // "/analytics/practiceSetAnalytics/.../recordUsage" for ATC Phraseology too.
    // All OTHER exports (users / usersSessionData / performance / usage) keep the ATC-specific
    // "/atc/analytics/practiceSetAnalytics/.../recordUsage" path for ATC Phraseology.
    const isAtc = this.selectedApp && (this.selectedApp.title == "ATC Phraseology" || this.selectedApp.name == "ATC Phraseology");
    if (analyticsType !== "session" && isAtc) {
      this.getAtcPsetsLiveSessionCsvData(analyticsType, type, nameStr);
    } else {
      this.getPsetsLiveSessionCsvData(analyticsType, type, nameStr);
    }
  }

  getPsetsLiveSessionCsvData(analyticsType, type, nameStr) {
    this.api.getPsetsLiveSessionCsvData(analyticsType, type, this.data.id, this.dateType.date, nameStr, null, this.liveSessionUsageValue).subscribe(
      (data) => {
        if (data.type === "application/zip") {
          var blob = new Blob([data], { type: data.type });
          FileSaver.saveAs(blob, analyticsType.toUpperCase() + ".zip");
        } else {
          var blob = new Blob([data], { type: "application/csv" });
          FileSaver.saveAs(blob, analyticsType.toUpperCase() + ".csv");
        }
      },
      (err) => {
        this.getError(err);
      }
    );
  }

  // ATC-specific export ("/atc/analytics/practiceSetAnalytics/.../recordUsage").
  // Used for all ATC exports EXCEPT the live-session ('session') export — see getCsvData().
  getAtcPsetsLiveSessionCsvData(analyticsType, type, nameStr) {
    this.api.getAtcPsetsLiveSessionCsvData(analyticsType, type, this.data.id, this.dateType.date, nameStr, null, this.liveSessionUsageValue).subscribe(
      (data) => {
        if (data.type === "application/zip") {
          var blob = new Blob([data], { type: data.type });
          FileSaver.saveAs(blob, analyticsType.toUpperCase() + ".zip");
        } else {
          var blob = new Blob([data], { type: "application/csv" });
          FileSaver.saveAs(blob, analyticsType.toUpperCase() + ".csv");
        }
      },
      (err) => {
        this.getError(err);
      }
    );
  }

  getError(err) {
    if (err.status == 401) {
      this.api.notifyInfo(AlertMessage.exitingCurrentSession);
      this.api.logmeout();
    }
  }

  ngOnDestroy() {
    if (this.subSink) this.subSink.unsubscribe();
    this.api.changeMessage({ type: "Day" });
  }
}
